import React from "react";
// MUI Components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";

// Icons
import WarningIcon from "@material-ui/icons/Warning";

// Other Files
import { colors } from "../../constants/colors";
import { customTheme } from "../../constants/customTheme";
import classNames from "classnames";

const useStyles = makeStyles({
  root: (props) => customTheme(props.theme).dialog.root,
  title: customTheme().dialog.title,
  contentContainer: customTheme().dialog.contentContainer,
  contentItem: customTheme().dialog.contentItem,
  buttonContainer: customTheme().dialog.buttonContainer,
  buttonPrimary: (props) => customTheme(props.theme).buttonPrimary,
  buttonOutlined: (props) => customTheme(props.theme).buttonOutlined,
  icon: {
    ...customTheme().titleIcon,
    color: (props) => colors.warning,
  },
});

const StudyDataUnavailableDialog = (props) => {
  const classes = useStyles(props);

  return (
    <Dialog
      open={props.open}
      PaperProps={{ className: classNames(classes.root) }}
    >
      <Typography
        className={classes.title}
        variant="h4"
        color="textPrimary"
        align="center"
      >
        <WarningIcon className={classes.icon} />
        <span>Study Data Unavailable</span>
      </Typography>
      <DialogContent className={classes.contentContainer}>
        <Typography
          className={classes.contentItem}
          color="textPrimary"
          align="center"
        >
          Data is not available locally for all the samples in your study. To
          view, you must load the study as locked and read-only.
        </Typography>
      </DialogContent>

      <DialogActions className={classes.buttonContainer}>
        <Button
          className={classes.buttonOutlined}
          onClick={props.onClose}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={props.handleLockUnlocked}
          variant="contained"
          color="primary"
          className={classes.buttonPrimary}
        >
          Load as Locked
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StudyDataUnavailableDialog;
